import { useState } from "react";
import { MoveHorizontal } from "lucide-react";

export default function BeforeAfter({ before, after, labels }) {
  const [pos, setPos] = useState(50);

  const move = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const p = ((e.clientX - rect.left) / rect.width) * 100;
    setPos(Math.min(96, Math.max(4, p)));
  };

  return (
    <div>
      <div
        data-testid="before-after-slider"
        className="relative aspect-[4/3] cursor-ew-resize select-none overflow-hidden rounded-[2rem] ring-1 ring-navy/10 sm:aspect-[16/10]"
        onPointerDown={(e) => {
          e.currentTarget.setPointerCapture(e.pointerId);
          move(e);
        }}
        onPointerMove={(e) => e.buttons === 1 && move(e)}
      >
        <img src={after} alt={labels.after} loading="lazy" className="absolute inset-0 h-full w-full object-cover" draggable={false} />
        <img
          src={before}
          alt={labels.before}
          loading="lazy"
          className="absolute inset-0 h-full w-full object-cover"
          style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }}
          draggable={false}
        />
        <span className="absolute left-4 top-4 rounded-full bg-navy/85 px-4 py-1.5 text-[11px] font-extrabold uppercase tracking-[0.15em] text-white backdrop-blur-sm">
          {labels.before}
        </span>
        <span className="absolute right-4 top-4 rounded-full bg-sky px-4 py-1.5 text-[11px] font-extrabold uppercase tracking-[0.15em] text-navy">
          {labels.after}
        </span>
        <div className="absolute inset-y-0 w-0.5 bg-white/90 shadow" style={{ left: `${pos}%` }}>
          <span className="absolute left-1/2 top-1/2 flex h-11 w-11 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full bg-white text-navy shadow-lg ring-1 ring-navy/10">
            <MoveHorizontal className="h-5 w-5" />
          </span>
        </div>
      </div>
      <p data-testid="before-after-demo-note" className="mt-3 text-center text-xs font-semibold italic text-mute">
        {labels.demo}
      </p>
    </div>
  );
}
